<script>
    export let Monsters

    let showOnPx = 70;
    let menuOn = false;
    function scrollPage() {
        return document.documentElement || document.body;
    }

    function handleOnScroll() {
        if (!scrollPage()) {
            return;
        }

        if (scrollPage().scrollTop >= showOnPx) {
            menuOn = true
        } else {
            menuOn = false
        }
    }

</script>

<svelte:window on:scroll={handleOnScroll} />

<div class="menu" class:menuOn>
    <ul>
        {#each Monsters as monster}
            <li><a href='#m_{monster.monster}'>{monster.name}</a></li>
        {/each}
    </ul>
</div>

<style lang="scss">
    .menu {
        background: $cl6;
        width: calc(100% - 20px);
        height: fit-content;
        padding: 15px;
        opacity: 0;

        position: fixed;
        top: 0;
        left: 0;
        z-index: 10;

        &.menuOn {
            transition : all .5s;
            opacity: 1;
        }

        ul {
            width: fit-content;
            margin: 4px auto;
            padding: 0;
            list-style: none;
            display:flex;
            flex-flow: row nowrap;

            li {
                margin-left: 5px;
                font-size: 20px;

                a {
                    color: $cl1;
                    font-size: 20px;
                    font-family: aggro;
                    cursor: pointer;

                    &:hover {
                        color: $cl2;
                    }
                }

                &::after {
                    margin-left: 5px;
                    color: $cl1;
                    content: "|";
                    cursor: default;
                }
                &:last-child::after{
                    content: "";
                }
            }
        }
    }
</style>



